import { render, staticRenderFns } from "./PieCard.vue?vue&type=template&id=583667bc"
import script from "./PieCard.vue?vue&type=script&lang=js"
export * from "./PieCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports